module.exports = __webpack_public_path__ + "static/media/bike-min.9299b5ae.png";